export default __webpack_public_path__ + "static/media/setting-active.71679e3e.svg";